import $ from 'jquery'

export const calendarEventSelectionMixin = {
    methods: {
        async selectEventInCalendar(eventId, expandedDay) {
            if (!eventId) return;

            let newDate;
            if (expandedDay) {
                newDate = expandedDay;
            } else {
                await this.updateSelectedEvent(eventId);
                newDate =this.getSelectedEvent.start.substring(0, 10);
            }

            const isCalendarRoute = ['calendarExpandedWithEventId', 'calendarExpanded', 'calendar']
                .includes(this.$route && this.$route.name);

            if (!isCalendarRoute) {
                this.$router.push({
                    name: 'calendarExpandedWithEventId',
                    params: { currentView: 'day', expandedDay: newDate, eventID: eventId }
                });
                return;
            }
            const waitingTime = 4000;
            const waitToast = this.$toasted && this.$toasted.info('Wait! Loading your event...', { duration: waitingTime });

            this.$router.push({
                name: 'calendarExpandedWithEventId',
                params: { currentView: 'day', expandedDay: newDate, eventID: eventId }
            });

            this.updateSidebar(newDate);
            await this.updateSelectedEvent(eventId);
            this.downloadGenderPricePerChannel(eventId);

            // Animate side panels similar to calendar click
            $('.events').addClass('showingMore');
            $('.events .list').addClass('moved-left');
            $('.events .more').removeClass('moved-right');

            waitToast.goAway(0);
            this.$toasted.success('Event found and loaded.', { duration: 2500 });

        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/calendarEventSelection.js